import React from 'react'
import TeamMember from './TeamMember'
import { useGetTeamsQuery } from '../features/team/teamApi'

export default function TeamMembers() {
    const { isLoading, isSuccess, data: teams, isError, error } = useGetTeamsQuery()

    let content = "";

    if (isLoading) {
        content = "Loading..."
    } else if (!isLoading && isSuccess && teams?.length > 0) {
        content = teams.map(team => <TeamMember key={team.id} team={team} />)
    } else if (!isLoading && isSuccess && teams?.length === 0) {
        content = "No task here."
    } else if (!isLoading && isError) {
        content = error?.message
    }

    return (
        <div className="mt-8">
            <h3 className="text-xl font-bold">Team Members</h3>
            <div className="mt-3 space-y-4">
                {content}
            </div>
        </div>
    )
}
